<template>
  <table-list ref="list"
              :request-params="{userNum: $route.query.num}"
              :data="tableData"
              @query="handleSearch">
    <el-table-column align="center" :label="$t('序号')" type="index" width="50" />
    <el-table-column align="center" :label="$t('图片')">
      <template v-slot="{row}">
       <preview-img :size="40" :img-url="row.photo" />
      </template>
    </el-table-column>
    <el-table-column align="center" :label="$t('工具名称')" prop="name" />
    <el-table-column align="center" :label="$t('收藏时间')">
      <template v-slot="{row}">
        {{row.createTime | formatDate}}
      </template>
    </el-table-column>
  </table-list>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request} from "@/config/request";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";
export default {
  name: "CollectTool",
  components: {PreviewImg, TableList},
  data() {
    return {
      tableData: [],
    }
  },
  methods: {
    async handleSearch(params, setTotal) {
      let res = await request(this.$api.cookToolCollect.list, params);
      this.tableData = res.cookToolCollects;
      setTotal(res.pager.itemCount);
    }
  }
}
</script>

<style scoped>

</style>
